import React, { useState, useEffect, useRef, useCallback } from "react"
import { CaretDown, CaretUp } from "@phosphor-icons/react"

const DropdownButtonLookook = ({
	itemRef,
	className = "dropdown-btn-style",
	label = "",
	defaultOption = "",
	caretSize = 20,
	useLabelName = undefined,
	optionListWidth = "min-w-20",
	options,
	onClick,
	noShadows = false,
	dropDownMargin = "mt-2",
	scrollRef = null,
}) => {
	const menuButtonRef = useRef(null)
	const [isDropDownOpen, setIsDropDownOpen] = useState(false)
	const [selectedOption, setSelectedOption] = useState(defaultOption)

	useEffect(() => {
		return () => {
			setIsDropDownOpen(false)
		}
	}, [])

	useEffect(() => {
		onClick(selectedOption)
	}, [selectedOption])

	const useSmartClickOutside = (ref, onOutsideTap) => {
		useEffect(() => {
			let isTouchMove = false

			const handleTouchStart = () => {
				isTouchMove = false
			}

			const handleTouchMove = () => {
				isTouchMove = true
			}

			const handleTouchEnd = (event) => {
				if (isTouchMove) return

				if (ref.current && !ref.current.contains(event.target)) {
					onOutsideTap()
				}
			}

			const handleMouseDown = (event) => {
				if (ref.current && !ref.current.contains(event.target)) {
					onOutsideTap()
				}
			}

			document.addEventListener("touchstart", handleTouchStart)
			document.addEventListener("touchmove", handleTouchMove)
			document.addEventListener("touchend", handleTouchEnd)
			document.addEventListener("mousedown", handleMouseDown)

			return () => {
				document.removeEventListener("touchstart", handleTouchStart)
				document.removeEventListener("touchmove", handleTouchMove)
				document.removeEventListener("touchend", handleTouchEnd)
				document.removeEventListener("mousedown", handleMouseDown)
			}
		}, [ref, onOutsideTap])
	}

	const handleClose = useCallback(() => setIsDropDownOpen(false), [])
	useSmartClickOutside(menuButtonRef, handleClose)

	useEffect(() => {

		// const handleClickOutside = (event) => {
		// 	if (
		// 		menuButtonRef.current &&
		// 		!menuButtonRef.current.contains(event.target)
		// 	) {
		// 		setIsDropDownOpen(false)
		// 	}
		// }

		if (isDropDownOpen) {
			if (scrollRef && itemRef) {
				const rect = itemRef.current.getBoundingClientRect()
				scrollRef(rect)
			}

			// document.addEventListener("mousedown", handleClickOutside)
			// document.addEventListener("touchstart", handleClickOutside)
		}

		// return () => {
		// 	document.removeEventListener("mousedown", handleClickOutside)
		// 	document.removeEventListener("touchstart", handleClickOutside)
		// }
	}, [isDropDownOpen])

	useEffect(() => {
		setSelectedOption(defaultOption)
	}, [defaultOption])

	return (
		<React.Fragment>
			<div ref={menuButtonRef} className="relative">
				<div
					className={`inline-flex w-full gap-x-1 md:gap-x-1.5 ${
						!noShadows && "shadow-sm"
					} hover:bg-gray-50 ${className}`}
				>
					<button
						className={`flex flex-nowrap gap-x-1 md:gap-x-3 justify-between items-center w-full select-none p-1 ${selectedOption?.title === '+' && 'pointer-events-none'}`}
						onClick={() => setIsDropDownOpen(!isDropDownOpen)}
						aria-label="size-dropdown"
					>
						{label && label}
						{selectedOption?.title}
						{
							selectedOption?.title !== '+' && (
								<>
									{isDropDownOpen ? (
										<CaretUp size={caretSize} weight="light" />
									) : (
										<CaretDown size={caretSize} weight="light" />
									)}
								</>
							)
						}
					</button>
				</div>

				{isDropDownOpen && (
					<div
						className={`absolute right-0 z-10 ${dropDownMargin} ${optionListWidth} origin-top-right bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none`}
					>
						<div className="flex flex-col">
							{options &&
								options?.map((item) => {
									return (
										<div
											className="cursor-pointer px-6 py-4 md:p-4 text-center md:text-left hover:bg-gray-50"
											key={`dp-${item.id}`}
											onClick={(e) => {
												setSelectedOption(item)
												setIsDropDownOpen(false)
											}}
										>
											<div>{item?.title}</div>
										</div>
									)
								})}
						</div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default DropdownButtonLookook
